import styled from 'styled-components'

import { Radio as InterRadio } from '@inter/inter-ui'

export const Radio = styled(InterRadio)`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
`
